import * as React from "react";

import {
	createStyles,
	withStyles,
	WithStyles,
	Theme,
} from "@material-ui/core/styles";
import { Grid, Button, GridProps } from "@material-ui/core";

// Utility

// NPM
import clsx from "clsx";
import { usePaymentManager } from "../../contexts/PaymentManager.Context";
import Utility from "../../domain/classes/Utility";

export const styles = (theme: Theme) =>
	createStyles({
		root: {
			display: "flex",
			position: "relative",
			marginTop: theme.spacing(1),
			flexFlow: "column",
		},
		signButton: { margin: "auto" },
		saveCardFormControlLabel: {
			margin: 0,
		},
	});

export interface CreditCardFrontActionButtonsProps extends GridProps {}

const CreditCardFrontActionButtons: React.FC<
	CreditCardFrontActionButtonsProps & WithStyles<typeof styles>
> = ({ classes, className }) => {
	// Contexts
	const { handleCardFlippedChange } = usePaymentManager();

	return (
		<Grid item xs={12} className={clsx(classes.root, className)}>
			<Button
				variant="contained"
				color="primary"
				className={classes.signButton}
				onClick={() => handleCardFlippedChange(true)}
			>
				Next
			</Button>
		</Grid>
	);
};

export default withStyles(styles, {
	classNamePrefix: Utility.generateClassName("CreditCardFrontActionButtons"),
})(CreditCardFrontActionButtons);
